export const pallete = {
    WHITE: "#FFF",
    BG_WHITE: "#FEFEFE",
    VIDEO_WHITE: "#F4F4F4",
    GOLDEN_YELLOW: "#FFA334",
    TEXT_BLACK: "#0E204D",
    ORANGE: "#FF5C00",
    BLUE: "#415CE0",
    DARK_BLUE: "#1B39CA",
    LIGHT_BLUE: "#5B80EA",
    BTN_HOVER_BLUE: "#ECEFFF",
    GREY: "#79798C",
    DIV_GREY: "#D0D1D9",
    BTN_DISABLE_GREY: "#C7C7C7",
    STEPPER_BG: "#273646",
    LIST_DIVIDER: "#4D6581",
    SCHEDULE_DIVIDER: "#EAECF0",
    TEXT_SUB: "#101C2D",
    RED: '#F56463',
    SELECTION: "#72C343",
    CARD_BG: "#EFF0F2",
    THEME_ONE: "#4F68EA",
}